import React from 'react';
import { useAppSelector } from "../../../../store/hooks";
import { SkinInterface } from "../../../../store/mine_craft/skinsSlice";
import { selectCategoryById } from "../../../../store/mine_craft/categoriesSlice";

import { RightSidebar } from "../../../_partials/Layout";
import ListVertical from "../../../../componets/ListVertical";
import ListItem from "../../categories/_partials/_ListItem";

const _SidebarShow = ({ skin }: { skin: SkinInterface | undefined }) => {
  const category        = useAppSelector(state => findCategory(state, skin?.category_id));
  const parentCategory  = useAppSelector(state => findCategory(state, skin?.subcategory_id));

  function findCategory(state: any, id: number | undefined) {
    return id ? selectCategoryById(state, id) : undefined
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      <h6 className="v-content-label o-sm">Category</h6>
      <ListVertical>
        <ListItem category={category} />
      </ListVertical>

      <h6 className="v-content-label o-sm v-mt-25">Subcategory</h6>
      <ListVertical>
        <ListItem category={parentCategory} />
      </ListVertical>
    </RightSidebar>
  )
}

export default _SidebarShow;
